import air_elemental from "./air_elemental.jsx";

export default {
  air_elemental,
};
